import { useQuery } from "react-query";
import axios from "axios";
import __ from "lodash";

import { getApiSitePrefix } from "../../functions/SiteDefaults";

const apiSitePrefix = getApiSitePrefix();

const augmentData = (data) => {
  const augmentedData = data.map((record) => {
    return {
      ...record, 
    }
  });
  return augmentedData;
}

let lastParams = undefined;

const buildArgs = (params) => {
  let argsList = {};
  if (params) {
    if (typeof params === "object") {
      argsList = __.cloneDeep(params);
    } else {
      console.error('useCostings: The params argument has to be an object, content ignored.')
    }
  }
  let args = "";
  if (argsList && Object.keys(argsList) && Object.keys(argsList).length > 0) {
    args = `?${Object.entries(argsList).map(([key, value]) => `${key}=${encodeURI(value)}`).join('&')}`;
  }
  return args;
}

const getData = async (tableRef, queryClient, key, extraKeys, useCache, callback, params) => {
  if (JSON.stringify(lastParams) === JSON.stringify(params)) {
    if (tableRef && tableRef.current && tableRef.current.state && tableRef.current.state.lastEditingRow){
      return queryClient.getQueryData(key);
    }
    if (useCache) {
      const cachedData = queryClient.getQueryData([...key, '_cached']);
      if (cachedData) {
        if (callback) {callback(cachedData, extraKeys)}
        return cachedData
      };
      const realData = queryClient.getQueryData(key);
      if (realData) {
        if (callback) {callback(realData, extraKeys)}
        return realData;
      }
    }
  }
  let extendedPath = "";
  if (extraKeys) {
    extendedPath = extraKeys.join("/");
  }
  const args = buildArgs(params);
  const { data } = await axios.get(
    `${apiSitePrefix}/costcategories/list/${extendedPath}${args}`
  );
  if (callback) {callback(data, extraKeys)}
  return augmentData(data);
};

const buildKey = (props) => {
  let key = ['CostCategories'];
  if (props.extraKeys) {
    key = [
      ...key,
      ...props.extraKeys
    ]
  }

  const args = buildArgs(props.params);
  if (args) {
    key.push(args);
  }

  const queryKey = [...key];
  if (props.useCache) {
    queryKey.push('_cached');
  }

  return {key, queryKey};
}

export default function useCostCategories(props) {    
  const options = {
    ...props.options
  }

  const {key, queryKey} = buildKey(props);

  return useQuery(
    queryKey, 
    () => getData(props.tableRef, props.queryClient, key, props.extraKeys, props.useCache, props.callback, props.params), 
    options
  );
}

const fetch = async (props) => {
  const options = {
    ...props.options
  }

  const {key, queryKey} = buildKey(props);

  return await props.queryClient.fetchQuery(
    queryKey,
    () => getData(props.tableRef, props.queryClient, key, props.extraKeys, props.useCache, props.callback, props.params),
    options
  );
}

export {buildKey, fetch}